export default {
  eventDay: 0,
  lastVisitedMonthValue: 0
};
